export default "__VITE_ASSET__DZAaCnbA__"